<template>
	<div class="phonebox">
		<van-popup :ref="modelRef" v-model="boxShow" position="bottom" :style="{ height: '90%' }" @close="hide"
			@closed="close" @opened="show" :safe-area-inset-bottom="true" :lazy-render="false" get-container="body">
			<div class="full flex" style="flex-direction: column;">
				<phone-grid style="flex: 1;" :gridOptions="gridOptions" type="box" :ref="ref"
					v-if="gridOptions && moduleName!=''" @toolbar-button-click="toolbarButtonClickEvent"
					@form-reset="formReset">
				</phone-grid>
				<van-button type="primary" size="" @click="submit(true)">确认</van-button>
			</div>
		</van-popup>

		<template v-if="buttonShow && !disabled && !readonly">
			<button class="van-action-sheet__item" v-if="!el" type="button" @click="alertBox">{{text}}</button>
			<van-button v-else type="info" color="#ffffff" @click="alertBox">
				<template #default>
					<van-icon :name="icon" size="20" color="#1989fa" v-if="!disabled && !readonly"></van-icon>
					<van-icon name="el-icon-lock" size="20" color="#1989fa" v-else></van-icon>
				</template>
			</van-button>
		</template>
	</div>
</template>
<style scoped>

</style>
<script>
	import boxbase from '@_system/components/base/box.vue'
	export default {
		extends: boxbase,
		props: {
			icon: {
				type: String,
				default: () => {
					return 'search'
				}
			},
		},
		data() {
			return {

			}
		},
		created() {


		},
		watch: {

		},
		mounted() {
			if (this.store.box) {
				this.store.box[this.code] = this
			} else {
				let obj = {}
				obj[this.code] = this
				this.store.box = obj
			}
		},
		methods: {
			preLoadData() {
				if(this.getTable()){
					this.getTable().commitProxy('query')
				}
			},
			show() {
				let fullData = this.getTable().getTableData().fullData
				if (fullData.length == 0) {
					this.getTable().commitProxy('query')
				}
			},
			close(close) {
				this.boxShow = false
				this.$refs[this.ref].clearCheckboxRow()
				if (close instanceof HTMLElement) {
					this.$emit('hide')
				}
			},
		},
		components: {

		}
	}
</script>
